import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import API_BASE_URL from "../../../helper.js";

// Function to show success modal
function showSuccessModal(message) {
    $("#successMessage").text(message);
    const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
    modal.show();
}

// ✅ MOVE FUNCTION OUTSIDE
function loadAllCarrers() {
    $.ajax({
        url: `${API_BASE_URL}/api/carrer/all`,
        type: "GET",
        success: function (carrers) {
            let rows = "";
            carrers.reverse().forEach((c, i) => {
                rows += `
                    <tr>
                        <td>${i + 1}</td>
                        <td>${c.position}</td>
                        <td>${c.course}</td>
                        <td>${c.jobType}</td>
                        <td>${c.experience}</td>
                        <td>${c.skills}</td>
                        <td>${c.postDate}</td>
                        <td>${c.description}</td>
                        <td>
                            <button class="btn btn-primary btn-sm editCarrerBtn" data-id="${c.id}">Edit</button>
                            <button class="btn btn-danger btn-sm deleteCarrer" data-id="${c.id}">Delete</button>
                        </td>
                    </tr>
                `;
            });

            $("#allCarrerData").html(rows);
        },
        error: function (err) {
            console.error(err);
        }
    });
}

// ✅ EXPOSE TO REACT
window.loadCarrers = function () {
    loadAllCarrers();
};

$(document).ready(function () {

    // ADD Carrer
    $("#addCarrerForm").submit(function (e) {
        e.preventDefault();

        const formData = new FormData();
        formData.append("position", $("#position").val());
        formData.append("course", $("#course").val());
        formData.append("jobType", $("#jobType").val());
        formData.append("experience", $("#experience").val());
        formData.append("skills", $("#skills").val());
        formData.append("description", $("#description").val());

        $.ajax({
            url: `${API_BASE_URL}/api/carrer/add`,
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            success: function () {
                showSuccessModal("Carrer Added Successfully!");
                $("#addCarrerForm")[0].reset();

                const modal = window.bootstrap.Modal.getInstance(document.getElementById("carrerModal"));
                modal.hide();
                loadAllCarrers();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to add Carrer!");
            }
        });
    });

    // OPEN EDIT MODAL
    $(document).on("click", ".editCarrerBtn", function () {
        const id = $(this).data("id");

        $.ajax({
            url: `${API_BASE_URL}/api/carrer/get/${id}`,
            type: "GET",
            success: function (c) {

                $("#editId").val(c.id);
                $("#editPosition").val(c.position);
                $("#editCourse").val(c.course);
                $("#editJobType").val(c.jobType);
                $("#editExperience").val(c.experience);
                $("#editSkills").val(c.skills);
                $("#editDescription").val(c.description);

                new window.bootstrap.Modal(document.getElementById("editCarrerModal")).show();
            },
            error: () => alert("Failed to fetch blog data")
        });
    });

    // UPDATE Carrer
    $("#editCarrerForm").submit(function (e) {
        e.preventDefault();

        const id = $("#editId").val();
        const formData = new FormData();

        formData.append("position", $("#editPosition").val());
        formData.append("course", $("#editCourse").val());
        formData.append("jobType", $("#editJobType").val());
        formData.append("experience", $("#editExperience").val());
        formData.append("skills", $("#editSkills").val());
        formData.append("description", $("#editDescription").val());

        $.ajax({
            url: `${API_BASE_URL}/api/carrer/update/${id}`,
            type: "POST",
            contentType: false,
            processData: false,
            data: formData,
            success: function () {
                showSuccessModal("Carrer Updated Successfully!");
                loadAllCarrers();
                window.bootstrap.Modal.getInstance(document.getElementById("editCarrerModal")).hide();
            },
            error: () => alert("Failed to update Carrer")
        });
    });
    
    // DELETE Carrer
    $(document).on("click", ".deleteCarrer", function () {
        let id = $(this).data("id");

        if (!window.confirm("Are you sure want to delete this Carrer?")) return;

        $.ajax({
            url: `${API_BASE_URL}/api/carrer/delete/${id}`,
            type: "DELETE",
            success: function () {
                showSuccessModal("Carrer Deleted Successfully!");
                loadAllCarrers();
            },
            error: function (err) {
                console.error(err);
                alert("Failed to delete Carrer!");
            }
        });
    });

});

// import $ from "jquery";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";
// import API_BASE_URL from "../../../helper.js";

// // Function to show success modal
// function showSuccessModal(message) {
//     $("#successMessage").text(message);
//     const modal = new window.bootstrap.Modal(document.getElementById("successModal"));
//     modal.show();
// }

// window.loadCarrers = function () {
//     loadAllCarrers();
// };

// $(document).ready(function () {

//     // ADD Carrer
//     $("#addCarrerForm").submit(function (e) {
//         e.preventDefault();

//         const formData = new FormData();
//         formData.append("position", $("#position").val());
//         formData.append("course", $("#course").val());
//         formData.append("jobType", $("#jobType").val());
//         formData.append("experience", $("#experience").val());
//         formData.append("skills", $("#skills").val());
//         formData.append("description", $("#description").val());

//         $.ajax({
//             url: `${API_BASE_URL}/api/carrer/add`,
//             type: "POST",
//             data: formData,
//             contentType: false,
//             processData: false,
//             success: function () {
//                 showSuccessModal("Carrer Added Successfully!");
//                 $("#addCarrerForm")[0].reset();

//                 const modal = window.bootstrap.Modal.getInstance(document.getElementById("carrerModal"));
//                 modal.hide();
//                 loadAllCarrers();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to add Carrer!");
//             }
//         });
//     });

//     // LOAD ALL Carrer DATA
//     function loadAllCarrers() {
//         $.ajax({
//             url: `${API_BASE_URL}/api/carrer/all`,
//             type: "GET",
//             success: function (carrers) {
//                 let rows = "";
//                 carrers.reverse().forEach((c, i) => {
//                     rows += `
//                         <tr>
//                             <td>${i + 1}</td>
//                             <td>${c.position}</td>
//                             <td>${c.course}</td>
//                             <td>${c.jobType}</td>
//                             <td>${c.experience}</td>
//                             <td>${c.skills}</td>
//                             <td>${c.postDate}</td>
//                             <td>${c.description}</td>
//                             <td>
//                                 <button class="btn btn-primary btn-sm editCarrerBtn" data-id="${c.id}">Edit</button>
//                                 <button class="btn btn-danger btn-sm deleteCarrer" data-id="${c.id}">Delete</button>
//                             </td>
//                         </tr>
//                     `;
//                 });

//                 $("#allCarrerData").html(rows);
//             },
//             error: function (err) {
//                 console.error(err);
//             }
//         });
//     }

//     // OPEN EDIT MODAL
//     $(document).on("click", ".editCarrerBtn", function () {
//         const id = $(this).data("id");

//         $.ajax({
//             url: `${API_BASE_URL}/api/carrer/get/${id}`,
//             type: "GET",
//             success: function (c) {

//                 $("#editId").val(c.id);
//                 $("#editPosition").val(c.position);
//                 $("#editCourse").val(c.course);
//                 $("#editJobType").val(c.jobType);
//                 $("#editExperience").val(c.experience);
//                 $("#editSkills").val(c.skills);
//                 $("#editDescription").val(c.description);

//                 new window.bootstrap.Modal(document.getElementById("editCarrerModal")).show();
//             },
//             error: () => alert("Failed to fetch blog data")
//         });
//     });

//     // UPDATE BLOG
//     $("#editCarrerForm").submit(function (e) {
//         e.preventDefault();

//         const id = $("#editId").val();
//         const formData = new FormData();

//         formData.append("position", $("#editPosition").val());
//         formData.append("course", $("#editCourse").val());
//         formData.append("jobType", $("#editJobType").val());
//         formData.append("experience", $("#editExperience").val());
//         formData.append("skills", $("#editSkills").val());
//         formData.append("description", $("#editDescription").val());

//         $.ajax({
//             url: `${API_BASE_URL}/api/carrer/update/${id}`,
//             type: "POST",
//             contentType: false,
//             processData: false,
//             data: formData,
//             success: function () {
//                 showSuccessModal("Carrer Updated Successfully!");
//                 loadAllCarrers();
//                 window.bootstrap.Modal.getInstance(document.getElementById("editCarrerModal")).hide();
//             },
//             error: () => alert("Failed to update Carrer")
//         });
//     });
    
//     // DELETE BLOG
//     $(document).on("click", ".deleteCarrer", function () {
//         let id = $(this).data("id");

//         if (!window.confirm("Are you sure want to delete this Carrer?")) return;

//         $.ajax({
//             url: `${API_BASE_URL}/api/carrer/delete/${id}`,
//             type: "DELETE",
//             success: function () {
//                 showSuccessModal("Carrer Deleted Successfully!");
//                 loadAllCarrers();
//             },
//             error: function (err) {
//                 console.error(err);
//                 alert("Failed to delete Carrer!");
//             }
//         });
//     });

// });

